import {
  BankAccountInfiniteSelectField,
  FloatingFormItem,
  InputDate,
  InputDecimal,
} from '@/components/_common';
import {
  InstallmentList,
  InstallmentSettleFormValues,
} from '@/core/domain/financial/AccountPayable/AccountPayable.types';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Col, Form, FormInstance, Row } from 'antd';
import React from 'react';
import moment from 'moment';
import useDefaultMinLengthNegativeFieldError from '@/hooks/useDefaultMinLengthNegativeFieldError';

interface Props {
  form: FormInstance<InstallmentSettleFormValues>;
  installments?: InstallmentList[];
}

const SettleMultipleInstallmentForm: React.FC<Props> = ({
  form,
  installments = [],
}) => {
  const defaultEmptyFieldError = useDefaultEmptyFieldError();
  const defaultMinLengthNegativeFieldError =
    useDefaultMinLengthNegativeFieldError();

  const installmentsMinValue = Math.min(
    ...installments.map((i) => i.installmentValue),
  );

  return (
    <Form form={form}>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <FloatingFormItem
            name={'bankAccountId'}
            label={'Conta bancária'}
            rules={
              installments
                ?.map((item) => !item.bankAccountId)
                .includes(0 || true)
                ? [defaultEmptyFieldError]
                : []
            }
          >
            <BankAccountInfiniteSelectField queryFilter={{ active: true }} />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <FloatingFormItem
            name={'payDate'}
            label={'Dia de pagamento'}
            rules={[defaultEmptyFieldError]}
            initialValue={moment()}
          >
            <InputDate />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <FloatingFormItem
            name="discountIncrease"
            label="Acres./Desc."
            rules={[
              defaultMinLengthNegativeFieldError(
                (installmentsMinValue ?? 0) * -1,
              ),
            ]}
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
};

export default SettleMultipleInstallmentForm;
